import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, trend, trendValue, icon, iconColor }) => {
  const isPositive = trend === 'up';
  
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-all duration-250">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground font-medium mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground truncate">{value}</h3>
        </div>
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ml-3 ${iconColor}`}>
          <Icon name={icon} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;